var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "id": "assign-booking-modal",
      "title": _vm.$t('reservation.assignBooking.title'),
      "title-class": "text-airline font-medium-4 font-weight-bolder",
      "centered": "",
      "no-close-on-backdrop": "",
      "no-enforce-focus": "",
      "hide-footer": "",
      "size": "md"
    },
    on: {
      "show": _vm.handleShowModal
    }
  }, [_c('validation-observer', {
    ref: "refFormObserver",
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var invalid = _ref.invalid,
          pristine = _ref.pristine;
        return [_c('div', [_c('h5', {
          staticClass: "mt-50"
        }, [_vm._v(" " + _vm._s(_vm.$t('reservation.chooseAgencyOrCustomerTitle')) + ": ")]), _c('b-row', [_c('b-col', {
          attrs: {
            "cols": "12",
            "md": "12"
          }
        }, [_c('validation-provider', {
          attrs: {
            "name": _vm.$t('reservation.agency'),
            "rules": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function fn(validationContext) {
              return [_c('b-form-group', {
                scopedSlots: _vm._u([{
                  key: "label",
                  fn: function fn() {
                    return [_c('div', [_vm._v(" " + _vm._s(_vm.$t('reservation.agency')) + " ")])];
                  },
                  proxy: true
                }], null, true)
              }, [_c('v-select', {
                staticClass: "w-100",
                attrs: {
                  "id": "agency-to-assign",
                  "state": _vm.getValidationState(validationContext) === false ? false : null,
                  "reduce": function reduce(val) {
                    return val;
                  },
                  "options": _vm.agencyToAssignOptions,
                  "label": "agencyCode",
                  "disabled": !_vm.isRoleF1,
                  "filterable": false,
                  "loading": _vm.loadingAgencies,
                  "placeholder": _vm.$t('reservation.placeholderSelect')
                },
                on: {
                  "open": _vm.handleOpenAgency,
                  "search": _vm.handleSearchAgency,
                  "input": _vm.handleInputAgency
                },
                scopedSlots: _vm._u([{
                  key: "selected-option",
                  fn: function fn(_ref2) {
                    var agencyName = _ref2.agencyName,
                      agencyCode = _ref2.agencyCode;
                    return [_c('div', [_c('span', {
                      staticClass: "d-block font-weight-bold text-truncate"
                    }, [_vm._v(" " + _vm._s(agencyName) + " "), _c('small', [_vm._v("(" + _vm._s(agencyCode) + ")")])])])];
                  }
                }, {
                  key: "option",
                  fn: function fn(_ref3) {
                    var agencyName = _ref3.agencyName,
                      agencyCode = _ref3.agencyCode;
                    return [_c('div', [_c('span', {
                      staticClass: "d-block font-weight-bold text-truncate"
                    }, [_vm._v(" " + _vm._s(agencyName) + " "), _c('small', [_vm._v("(" + _vm._s(agencyCode) + ")")])])])];
                  }
                }, {
                  key: "spinner",
                  fn: function fn(_ref4) {
                    var loading = _ref4.loading;
                    return [loading ? _c('div', {
                      staticClass: "vs__spinner",
                      staticStyle: {
                        "border-left-color": "rgba(88, 151, 251, 0.71)"
                      }
                    }) : _vm._e()];
                  }
                }, {
                  key: "no-options",
                  fn: function fn() {
                    return [_vm._v(" " + _vm._s(_vm.$t('noOptions')) + " ")];
                  },
                  proxy: true
                }], null, true),
                model: {
                  value: _vm.agencyToAssign,
                  callback: function callback($$v) {
                    _vm.agencyToAssign = $$v;
                  },
                  expression: "agencyToAssign"
                }
              }), _c('b-form-invalid-feedback', [_vm._v(" " + _vm._s(validationContext.errors[0]) + " ")])], 1)];
            }
          }], null, true)
        })], 1), _c('b-col', {
          attrs: {
            "cols": "12",
            "md": "12"
          }
        }, [_c('validation-provider', {
          attrs: {
            "name": _vm.$t('reservation.customer'),
            "rules": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function fn(validationContext) {
              return [_c('b-form-group', {
                scopedSlots: _vm._u([{
                  key: "label",
                  fn: function fn() {
                    return [_c('div', [_vm._v(" " + _vm._s(_vm.$t('reservation.customer')) + " ")])];
                  },
                  proxy: true
                }], null, true)
              }, [_c('v-select', {
                staticClass: "w-100",
                attrs: {
                  "state": _vm.getValidationState(validationContext) === false ? false : null,
                  "reduce": function reduce(val) {
                    return val;
                  },
                  "label": "code",
                  "filterable": false,
                  "options": _vm.customerToAssignOptions,
                  "disabled": !_vm.isRoleF1,
                  "loading": _vm.loadingCustomers,
                  "placeholder": _vm.$t('reservation.placeholderSelect')
                },
                on: {
                  "open": _vm.handleOpenCustomer,
                  "search": _vm.handleSearchCustomer,
                  "input": _vm.handleInputCustomer
                },
                scopedSlots: _vm._u([{
                  key: "selected-option",
                  fn: function fn(_ref5) {
                    var lastName = _ref5.lastName,
                      firstName = _ref5.firstName,
                      code = _ref5.code;
                    return [_c('div', [_c('span', {
                      staticClass: "d-block font-weight-bold text-truncate"
                    }, [_vm._v(" " + _vm._s("".concat(lastName, " ").concat(firstName)) + " "), _c('small', [_vm._v("(" + _vm._s(code) + ")")])])])];
                  }
                }, {
                  key: "option",
                  fn: function fn(_ref6) {
                    var lastName = _ref6.lastName,
                      firstName = _ref6.firstName,
                      code = _ref6.code;
                    return [_c('div', [_c('span', {
                      staticClass: "d-block font-weight-bold text-truncate"
                    }, [_vm._v(" " + _vm._s("".concat(lastName, " ").concat(firstName)) + " "), _c('small', [_vm._v("(" + _vm._s(code) + ")")])])])];
                  }
                }, {
                  key: "spinner",
                  fn: function fn(_ref7) {
                    var loading = _ref7.loading;
                    return [loading ? _c('div', {
                      staticClass: "vs__spinner",
                      staticStyle: {
                        "border-left-color": "rgba(88, 151, 251, 0.71)"
                      }
                    }) : _vm._e()];
                  }
                }, {
                  key: "no-options",
                  fn: function fn() {
                    return [_vm._v(" " + _vm._s(_vm.$t('noOptions')) + " ")];
                  },
                  proxy: true
                }], null, true),
                model: {
                  value: _vm.customerToAssign,
                  callback: function callback($$v) {
                    _vm.customerToAssign = $$v;
                  },
                  expression: "customerToAssign"
                }
              }), _c('b-form-invalid-feedback', [_vm._v(" " + _vm._s(validationContext.errors[0]) + " ")])], 1)];
            }
          }], null, true)
        })], 1)], 1)], 1), _c('div', {
          staticClass: "mt-1 d-flex-center gap-2"
        }, [_c('b-button', {
          attrs: {
            "variant": "gradient",
            "pill": "",
            "block": _vm.$store.getters['app/currentBreakPoint'] === 'xs',
            "disabled": invalid || pristine
          },
          on: {
            "click": _vm.confirmFindPnrCode
          }
        }, [_vm._v(" " + _vm._s(_vm.$t('reservation.assignBooking.title')) + " ")])], 1)];
      }
    }])
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }